import React, { useEffect, useState } from 'react';
import {Link} from 'react-router-dom';
import AdComponent from '../ads/AdComponent';
import { LeagueDetailDto, LeagueParticipantDto, LeagueSessionParticipantRankResponse } from '@playball/common/dto/League';
import { useAuth } from '../../context/AuthContext';
import { DataResponse } from '@playball/common/dto/Common';


const ResultComponent: React.FC<{ league: LeagueDetailDto }> = ({ league }) => {

    const { fetchApi } = useAuth();
    const [rankList, setRankList] = useState<LeagueParticipantDto[]>([]);
    const [myRank, setMyRank] = useState<number>(0);

    useEffect(() => {
        const fetchData = async () => {
            if (!league.code) return;

            const res: DataResponse<LeagueSessionParticipantRankResponse> = await fetchApi(`/api/league/session/${league.code}/rank`);
            if (res.data?.rankList) {
                setRankList(res.data.rankList);
                
                const myRank = res.data.rankList.find(r => r.user_code === league.my_user_code);
                if (myRank) {
                    setMyRank(myRank.rank);
                } else {
                    setMyRank(0);
                }
            }
        };

        fetchData();
    }, [league.code, league.my_user_code, fetchApi]);

    const getCongratulatoryContent = (rank: number) => {
        if (rank === 1) return { icon: '🏆', message: '축하합니다! 리그 1위를 달성하셨습니다!', color: 'text-amber-400' };
        if (rank === 2) return { icon: '🥈', message: '훌륭합니다! 리그 2위를 차지했습니다!', color: 'text-slate-400' };
        if (rank === 3) return { icon: '🥉', message: '멋진 성적입니다! 리그 3위입니다!', color: 'text-amber-600' };
        return { icon: '👍', message: '다음 리그에서 더 좋은 결과를 기대해봅니다!', color: 'text-gray-500' };
    };

    const congrats = getCongratulatoryContent(myRank);
    
    return (
        <>
            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="card text-center shadow-lg overflow-hidden fade-in">
                            <div className="card-body p-4 p-lg-5 position-relative">
                                {/* 1~3위일 때만 배경 이미지 표시 */}
                                {myRank > 0 && myRank <= 3 && (
                                    <div 
                                        className="position-absolute top-0 start-0 w-100 h-100"
                                        style={{ 
                                            backgroundImage: `url("/images/bg_result_top.png")`,
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat',
                                            backgroundSize: 'cover',
                                            opacity: 0.1,
                                            filter: 'blur(2px)'
                                        }}
                                    ></div>
                                )}
                                <div className="position-relative">
                                    <h2 className="h1 fw-bold text-dark mb-2">{league.name}</h2>
                                    <p className="text-muted mb-4">리그가 종료되었습니다.</p>

                                    {myRank > 0 && (
                                        <div className="my-5">
                                            <div className={`display-1 fw-bolder ${congrats.color}`}>{congrats.icon}</div>
                                            <h1 className="display-4 fw-bold my-2">{myRank}위</h1>
                                            <p className={`fs-5 fw-semibold ${congrats.color}`}>{congrats.message}</p>
                                        </div>
                                    )}

                                    <AdComponent />

                                    <div className="bg-light p-4 rounded-3">
                                        <h4 className="h5 fw-bold mb-4 text-dark">최종 순위</h4>
                                        <table className="table table-striped text-start">
                                            <thead>
                                                <tr>
                                                    <th className="p-2 fw-semibold">순위</th>
                                                    <th className="p-2 fw-semibold">참가자</th>
                                                    <th className="p-2 fw-semibold text-end">점수</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {rankList.map((user) => (
                                                    <tr key={user.user_code}>
                                                        <td className="p-2 fw-bold">{user.rank}</td>
                                                        <td className="p-2">{user.name}</td>
                                                        <td className="p-2 text-end fw-semibold">{user.score}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="mt-4">
                                        <Link to="/dashboard" className="btn btn-primary rounded-pill px-4 py-2">
                                            대시보드로 돌아가기
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <style>{`
                /* 추가적인 커스텀 스타일이 필요하다면 여기에 작성할 수 있습니다. */
                .card {
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                }
                .card:hover { 
                    transform: translateY(-5px);
                    box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
                }
                .fade-in {
                    animation: fadeIn 0.7s ease-in-out;
                }
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
            `}</style>
        </>
    );
}

export default ResultComponent;